<template>
  <sa-page-layout :showModalLoading="showModalLoading" :btnEditVisible="true" :btnBackVisible="true" :linkedit="linkedit" :linkback="linkback" :pathResource="pathResource" :data="jsonData">
    <template slot="toolbar-title">
      <paziente-anagrafica :linkPatient="linkPatient" :idPaziente="idPaziente"></paziente-anagrafica>
    </template>
    <template slot="table-header">
      <!-- <h5 class="sa-text-left">{{ this.$i18n.t("pazienti.egds.lblData") }}</h5> -->
    </template>
    <template slot="table-body">
      <div class="sa-tab-scroll">
        <div class="sa-form-section">
          <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <strong>{{ this.$i18n.t("pazienti.egds.lblDescription") }}</strong>
              <br />
              {{ jsonData.descrizione }}
            </b-col>
          </b-row>
        </div>
      </div>
      <hr />
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PazienteAnagrafica from "../../../components/PazienteAnagrafica.vue";
export default {
  components: { SaPageLayout, PazienteAnagrafica },
  props: {
    utente: {
      type: Object,
      default: function() {
        return { gruppo: { menuGruppo: [] } };
      },
    },
  },
  data() {
    return {
      linkedit: null,
      linkback: null,
      pathResource: "/gastroenterologiaegdslavaggiodisinfezione",
      jsonData: {},
      showModalLoading: false,
    };
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.linkedit = "/paziente/gastroenterologia/configurazioneegds/lavaggiodisinfezione/edit/" + me.id + "?idPaziente=" + me.idPaziente;
    me.linkback = "/paziente/gastroenterologia/configurazioneegds/lavaggiodisinfezione?idPaziente=" + me.idPaziente;
    me.loadData();
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient: {
      get: function() {
        if (this.utente.gruppo.menuGruppo) {
          if (this.utente.gruppo.menuGruppo.length > 1) {
            return "/paziente/view/" + this.idPaziente;
          } else {
            if (this.utente.gruppo.menuGruppo.length == 1) {
              if (this.utente.gruppo.menuGruppo[0].primaryKey === "pazienti") {
                return "/paziente/view/" + this.idPaziente;
              } else {
                return "/paziente/homepaziente";
              }
            } else {
              return "";
            }
          }
        } else {
          return "";
        }
      },
    },
  },
  methods: {
    loadData() {
      let me = this;
      if (me.id === "-1") {
        me.showModalLoading = false;
      } else {
        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
        axios.get(link).then((response) => {
          me.jsonData = response.data.data;
          console.log(me.jsonData);
          me.showModalLoading = false;
        });
      }
    },
  },
};
</script>
